import { useCallback, useEffect, useRef } from "react";
import useQueryFetch from "../../../modules/api/apiHooks/useQueryFetch";
import { getAtkHeader } from "../../../modules/api/fetch/getHeaders";
import { Tag } from "../../../modules/graphql/api.generated";
import { GET_TAGS } from "../../../modules/graphql/searchGraphQL";
import { useSearchResultSelector } from "../../../modules/search/searchContext/searchContextHooks";
import CardItem from "../../category/list/cardItem/CardItem";
import FullPageLoading from "../../shared/loading/FullPageLoading";
import CastRowComponent from "./castRow/castRowComponent";
import ProgramRowComponent from "./programRow/programRowComponent";
import * as styles from "./styles.module.scss";
import TagRowComponent from "./tagRow/tagRowComponent";

const RowSectionComponent = () => {
  const rowSectionData = useSearchResultSelector();
  const scrollingRef = useRef<any>(null);
  const offsetLeftRef = useRef<any>(null);

  const [getTags, tagsContext] = useQueryFetch(
    process.env.TV_API_BASE_URL!,
    GET_TAGS,
    getAtkHeader,
    // variables: {
    //   tagTypeID: 'dd27af61-3cac-4b52-bfca-e282b7aedb0c',
    //   page: 1,
    // },
  );

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    const tags = await getTags({ tagTypeID: "dd27af61-3cac-4b52-bfca-e282b7aedb0c", page: 1 });
  };

  const onTagCardFocus = useCallback((l, index) => {
    offsetLeftRef.current = l;

    // Calculate the row index based on the item index
    const rowIndex = Math.floor(index / 5); // Assuming 5 items per row
    const itemIndexInRow = index % 5; // Index of the item within its row

    // Calculate the scroll position based on the row index and item height
    scrollingRef.current.style.transform = `translateY(${-Math.round(rowIndex * l.height)}px)`;
    scrollingRef.current.style["-webkit-transform"] = `translateY(${-Math.round(rowIndex * l.height)}px)`;
  }, []);

  if (rowSectionData && rowSectionData.loading) {
    return <FullPageLoading loadingText="در حال جستجو" />;
  }

  return (
    <div className={styles.container}>
      <div ref={scrollingRef} className={styles.tagCardContainer}>
        {(!rowSectionData || (!rowSectionData.tags && !rowSectionData.artists && !rowSectionData.items)) &&
          tagsContext.data &&
          tagsContext.data?.data?.getTags.data.map((item: Tag, index) => (
            <CardItem
              key={`movie-item-${index}`}
              focusKey={`card${index}`}
              link={`/g/${item.descriptor}`}
              landscapeImagePath={item.landscapeImagePath}
              onFocus={(l, e) => onTagCardFocus(l, index)}
            />
          ))}
      </div>
      {rowSectionData?.artists?.length === 0 &&
        rowSectionData?.items?.length === 0 &&
        rowSectionData?.tags?.length === 0 && (
          <div className={styles.notFound}>متاسفیم، نتیجه‌ای برای جستجوی شما یافت نشد.</div>
        )}
      {rowSectionData && rowSectionData.tags && rowSectionData.tags.length > 0 && (
        <section className={styles.rowWrapper}>
          <div className={styles.title}>دسته بندی ها</div>
          <TagRowComponent tags={rowSectionData.tags} />
        </section>
      )}
      {rowSectionData && rowSectionData.items && rowSectionData.items.length > 0 && (
        <section className={styles.rowWrapper}>
          <div className={styles.title}> نتایج جستجو</div>
          <ProgramRowComponent data={rowSectionData.items} itemPerRow={4} />
        </section>
      )}
      {rowSectionData && rowSectionData.artists && rowSectionData.artists.length > 0 && (
        <section className={styles.rowWrapper}>
          <div className={styles.title}> بازیگران و عوامل</div>
          <CastRowComponent data={rowSectionData.artists} />
        </section>
      )}
    </div>
  );
};
export default RowSectionComponent;
